<app-card-layout [info]="info" (change)="eventTriggered($event)"></app-card-layout>

<div *ngIf="showNameDialog" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.2); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000;">
  <div style="background: #fff; border-radius: 8px; padding: 28px 32px; min-width: 420px; box-shadow: 0 8px 30px rgba(0,0,0,0.15);">
    <h3 style="margin: 0 0 20px 0; font-size: 20px; font-weight: 600; color: #333;">Edit Name</h3>
    <input
      [(ngModel)]="newName"
      placeholder="Enter name"
      [disabled]="updatingName"
      style="width: 100%; padding: 10px 12px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; box-sizing: border-box; outline: none;"
    />
    <div *ngIf="nameErrorMsg" style="color: red; margin-top: 6px; font-size: 12px;">{{ nameErrorMsg }}</div>
    <span *ngIf="updatingName" style="display: block; margin-top: 8px; font-size: 13px; color: #666;">Updating...</span>
    <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
      <button
        (click)="closeNameDialog()"
        [disabled]="updatingName"
        style="padding: 8px 20px; border: none; background: none; color: #555; font-size: 14px; font-weight: 500; cursor: pointer;"
      >Cancel</button>
      <button
        (click)="submitName()"
        [disabled]="updatingName || !newName"
        style="padding: 8px 24px; border: none; border-radius: 4px; background: #1a73e8; color: #fff; font-size: 14px; font-weight: 500; cursor: pointer;"
        [style.opacity]="(updatingName || !newName) ? '0.6' : '1'"
      >Submit</button>
    </div>
  </div>
</div>

<div *ngIf="showEmailDialog" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.2); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000;">
  <div style="background: #fff; border-radius: 8px; padding: 28px 32px; min-width: 420px; box-shadow: 0 8px 30px rgba(0,0,0,0.15);">
    <h3 style="margin: 0 0 20px 0; font-size: 20px; font-weight: 600; color: #333;">Edit Email</h3>
    <div class="email-lookup-row">
      <input
        class="email-lookup-input"
        [(ngModel)]="newEmail"
        placeholder="Enter corporate email"
        [disabled]="updatingEmail"
      />
      <button
        type="button"
        class="email-lookup-btn"
        (click)="lookupEmailDomain()"
        [disabled]="updatingEmail || domainTypeLookupLoading || !canLookupEmail()"
      >
        <span *ngIf="domainTypeLookupLoading" class="email-lookup-spinner" aria-label="Loading"></span>
        <span *ngIf="!domainTypeLookupLoading">Lookup</span>
      </button>
    </div>
    <label style="display: block; margin-top: 12px;">
      Domain type
      <select [(ngModel)]="domainType" [disabled]="updatingEmail || domainTypeLookupLoading" style="width: 100%; margin-top: 4px; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">
        <option value="" disabled>Select domain type</option>
        <option *ngFor="let option of domainTypeOptions" [value]="option">{{ option }}</option>
      </select>
    </label>
    <div style="margin-top: 6px; font-size: 12px; color: #888;" *ngIf="!errorMsg">Must be valid corporate email</div>
    <div *ngIf="errorMsg" style="color: red; margin-top: 6px; font-size: 12px;">{{ errorMsg }}</div>
    <span *ngIf="updatingEmail" style="display: block; margin-top: 8px; font-size: 13px; color: #666;">Updating...</span>
    <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
      <button
        (click)="closeEmailDialog()"
        [disabled]="updatingEmail"
        style="padding: 8px 20px; border: none; background: none; color: #555; font-size: 14px; font-weight: 500; cursor: pointer;"
      >Cancel</button>
      <button
        (click)="submitEmail()"
        [disabled]="updatingEmail || domainTypeLookupLoading || !newEmail || !domainType"
        style="padding: 8px 24px; border: none; border-radius: 4px; background: #1a73e8; color: #fff; font-size: 14px; font-weight: 500; cursor: pointer;"
        [style.opacity]="(updatingEmail || !newEmail) ? '0.6' : '1'"
      >Submit</button>
    </div>
  </div>
</div>

<div *ngIf="showDeleteEmailDialog" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.2); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000;">
  <div style="background: #fff; border-radius: 8px; padding: 28px 32px; min-width: 420px; box-shadow: 0 8px 30px rgba(0,0,0,0.15);">
    <h3 style="margin: 0 0 12px 0; font-size: 20px; font-weight: 600; color: #333;">Delete Email</h3>
    <p style="margin: 0 0 20px 0; font-size: 14px; color: #555;">Are you sure you want to delete this corporate email?</p>
    <div *ngIf="deleteErrorMsg" style="color: red; margin-bottom: 12px; font-size: 12px;">{{ deleteErrorMsg }}</div>
    <span *ngIf="deletingEmail" style="display: block; margin-bottom: 12px; font-size: 13px; color: #666;">Deleting...</span>
    <div style="display: flex; justify-content: flex-end; gap: 12px;">
      <button
        (click)="closeDeleteEmailDialog()"
        [disabled]="deletingEmail"
        style="padding: 8px 20px; border: none; background: none; color: #555; font-size: 14px; font-weight: 500; cursor: pointer;"
      >Cancel</button>
      <button
        (click)="deleteEmail()"
        [disabled]="deletingEmail"
        style="padding: 8px 24px; border: none; border-radius: 4px; background: #d93025; color: #fff; font-size: 14px; font-weight: 500; cursor: pointer;"
        [style.opacity]="deletingEmail ? '0.6' : '1'"
      >Delete</button>
    </div>
  </div>
</div>
